import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';
import { acceptHMRUpdate } from 'pinia';

export const useRuleSetStore = defineStore('ruleSet', () => {
    const all = ref(null);

    const form = ref({
        products: [],
        labels: [],
    });

    const detail = ref(null);

    const reset = () => {
        all.value = null;
        form.value = { products: [], labels: [] };
        detail.value = null;
    };

    const search = (params) => axios.get('/api/v1/rule-sets', { params });
    const getForm = () => axios.get('/api/v1/rule-sets/form');
    const store = (payload) => axios.post('/api/v1/rule-sets', payload);
    const update = (hash, payload) => axios.patch(`/api/v1/rule-sets/${hash}`, payload);

    return {
        all,
        form,
        detail,
        reset,
        search,
        getForm,
        store,
        update,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useRuleSetStore, import.meta.hot));
}
